import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { fetchJackpots } from 'store/modules/jackpotsFromProviders/actions'
import { getProvidersJackpotsIsLoadedSelector } from 'store/modules/jackpotsFromProviders/selectors'

import { jackpotsFromProvidersConfig } from '../config'

export function useFetchProvidersJackpots() {
  const { apiUrl, ignoredRoutesToFetch } = jackpotsFromProvidersConfig.feature
  const pathname = usePathname()
  const dispatch = useAppDispatch()
  const isAppInitialized = useAppSelector(isAppInitializedSelector)
  const isLoaded = useAppSelector(getProvidersJackpotsIsLoadedSelector)

  const isIgnoredRoute = ignoredRoutesToFetch?.includes(pathname)

  useEffect(() => {
    if (apiUrl && isAppInitialized && !isLoaded && !isIgnoredRoute) {
      dispatch(fetchJackpots(apiUrl))
    }
  }, [dispatch, apiUrl, isIgnoredRoute, isLoaded, isAppInitialized])
}
